export default __webpack_public_path__ + "static/media/jrc_logo_icon.49688d8a.png";